/**
 * @generated SignedSource<<e15c22cc8ccbd0a6e33fad0d8cd86176>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExternalServiceLinksCustomerAccountQuery$variables = {
  customerAccountIdentifier: string;
};
export type ExternalServiceLinksCustomerAccountQuery$data = {
  readonly customerAccountExternalLinks: ReadonlyArray<{
    readonly iconUrl: string | null | undefined;
    readonly label: string;
    readonly service: string;
    readonly url: string;
  }>;
};
export type ExternalServiceLinksCustomerAccountQuery = {
  response: ExternalServiceLinksCustomerAccountQuery$data;
  variables: ExternalServiceLinksCustomerAccountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerAccountIdentifier"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerAccountIdentifier",
        "variableName": "customerAccountIdentifier"
      }
    ],
    "concreteType": "ExternalServiceLink",
    "kind": "LinkedField",
    "name": "customerAccountExternalLinks",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "service",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "label",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "iconUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalServiceLinksCustomerAccountQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalServiceLinksCustomerAccountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d2b18bfac729b26e5bd4116102eba7fe",
    "id": null,
    "metadata": {},
    "name": "ExternalServiceLinksCustomerAccountQuery",
    "operationKind": "query",
    "text": "query ExternalServiceLinksCustomerAccountQuery(\n  $customerAccountIdentifier: ID!\n) {\n  customerAccountExternalLinks(customerAccountIdentifier: $customerAccountIdentifier) {\n    service\n    label\n    url\n    iconUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "21dc824c42686f52a814f0fe3babeb2b";

export default node;
